import React, { memo, useState, useCallback, useRef, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { WeatherBugBigIcon } from '../../common/icons/weatherBugBigIcon';
import { navHamburgerMenuQuery, smallMediaQuery } from '../../../common/utilities/sizeHelpers';
import { HamburgerLogoIcon } from './hamburgerLogoIcon';
import { TextOnlyLogoIcon } from './textOnlyLogoIcon';
import { HamburgerNav } from './hamburgerNav';
import { reduxConnect } from '../../../common';
import { withScreenSize } from '../../common/utilities/withScreenSize.jsx';

const mapStoreStateToProps = (storeState) => {
    const { pageId } = storeState?.appState?.appState || {};

    return {
        pageId
    };
};

const mapDispatchToProps = {};

export const NavbarLogo = memo(reduxConnect(mapStoreStateToProps, mapDispatchToProps)(withScreenSize(({ pageId, isDesktop }) => {
    const [ hamburgerNavOpen, setHamburgerNavOpen ] = useState(false);
    const toggleHamburgerNav = useCallback(() => {
        setHamburgerNavOpen(!hamburgerNavOpen);
    });
    const currentPageId = useRef();
    const currentPageHref = useRef(window.location.href);

    useEffect(() => {
        const pageHref = window.location.href;
        if (!isDesktop) {
            if (pageId && !currentPageId.current) {
                currentPageId.current = pageId;
            }

            if ((pageId && currentPageId.current && pageId !== currentPageId.current) ||
                (currentPageHref !== pageHref)) {
                currentPageId.current = pageId;
                currentPageHref.current = pageHref;
                if (hamburgerNavOpen) {
                    toggleHamburgerNav();
                }
            }
        }
    }, [pageId, window.location.href]);

    return <>
        <LargeScreenLogoLink href='/weather-forecast/now/'>
            <WeatherBugBigIcon />
        </LargeScreenLogoLink>
        <HamburgerLogoContainer>
            <ClickableContainer onClick={toggleHamburgerNav}>
                <HamburgerLogoIcon />
            </ClickableContainer>
            <TextLogoContainer>
                <TextOnlyLogoIcon />
            </TextLogoContainer>
            { hamburgerNavOpen && <HamburgerNav onClose={toggleHamburgerNav} /> }
        </HamburgerLogoContainer>
    </>;
})));

NavbarLogo.displayName = 'NavbarLogo';
NavbarLogo.propTypes = {
    pageId: PropTypes.string
};

const LargeScreenLogoLink = styled.a`
    display: flex;
    align-items: center;
    ${navHamburgerMenuQuery} {
        display: none;
    };
`;

const HamburgerLogoContainer = styled.div`
    display: none;
    ${navHamburgerMenuQuery} {
        display: flex;
        align-items: center;
    };
`;

const TextLogoContainer = styled.div`
    margin-top: 4px;
    @media${smallMediaQuery} {
        display: none;
    }
`;

const ClickableContainer = styled.div`
    cursor: pointer;
`;
